/**
 * Types pour le système de personnalisation du Dashboard.
 * Architecture extensible pour future migration vers Supabase.
 */

/** Identifiants uniques des widgets du Dashboard */
export type DashboardWidgetId = 'quick_access' | 'bank_links' | 'dashboard_sidebar';

/** Widgets réorganisables (inclut la sidebar mémos) */
export type SortableWidgetId = 'quick_access' | 'bank_links' | 'dashboard_sidebar';

/** Configuration de visibilité d'un widget */
export interface WidgetVisibilityConfig {
  widgetId: DashboardWidgetId;
  enabled: boolean;
}

/** Préférences utilisateur du Dashboard (stockage local ou futur Supabase) */
export interface DashboardPreferences {
  /** Version du schéma pour migrations futures */
  version: number;
  /** Configuration de visibilité par widget */
  widgets: Record<DashboardWidgetId, boolean>;
  /** Ordre vertical des widgets (extensible pour grille) */
  widgetOrder: SortableWidgetId[];
  /** Date de dernière mise à jour */
  updatedAt: string;
}

/** Ordre par défaut des widgets */
export const DEFAULT_WIDGET_ORDER: SortableWidgetId[] = [
  'quick_access',
  'bank_links',
  'dashboard_sidebar',
];

/** Valeurs par défaut des préférences */
export const DEFAULT_DASHBOARD_PREFERENCES: DashboardPreferences = {
  version: 1,
  widgets: {
    quick_access: true,
    bank_links: true,
    dashboard_sidebar: true,
  },
  widgetOrder: [...DEFAULT_WIDGET_ORDER],
  updatedAt: new Date().toISOString(),
};
